export * from './out.component';